import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

let isGPTScriptLoaded = false;
let definedSlots = new Set();

const AdComponent = ({
  adUnitPath = "/6355419/Travel/Europe/France/Paris",
  slotId = "banner-ad"
}) => {
  const adRef = useRef(null);

  function initAdSlot() {
    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd.push(() => {
      if (!definedSlots.has(slotId)) {
        const slot = window.googletag
          .defineSlot(
            adUnitPath,
            [
              [970, 90],
              [728, 90],
              [300, 250]
            ],
            slotId
          )
          .addService(window.googletag.pubads());
        const mapping = window.googletag
          .sizeMapping()
          .addSize([1200, 0], [[728, 90]]) // ≥ 1200px ekran genişliği için
          .addSize([768, 0], [[728, 90]]) // ≥ 768px
          .addSize([0, 0], [[300, 250]])
          .build();
        slot.defineSizeMapping(mapping);
        definedSlots.add(slotId);

        window.googletag.enableServices();
        window.googletag.display(slotId);
        window.googletag.pubads().refresh([slot]);
      } else {
        const slot = window.googletag
          .pubads()
          .getSlots()
          .find((s) => s.getSlotElementId() === slotId);

        if (slot) {
          window.googletag.display(slotId);
          window.googletag.pubads().refresh([slot]);
        }
      }
    });
  }

  useEffect(() => {
    // GPT script'i yükle (sadece 1 kere)
    if (!isGPTScriptLoaded) {
      const gptScript = document.createElement("script");
      gptScript.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
      gptScript.async = true;
      document.head.appendChild(gptScript);

      gptScript.onload = () => {
        isGPTScriptLoaded = true;
        initAdSlot();
      };
    } else {
      initAdSlot();
    }

    // Optional: unmount sırasında cleanup yapılabilir (isteğe bağlı)
    return () => {
      if (definedSlots.has(slotId)) {
        const slot = window.googletag
          .pubads()
          .getSlots()
          .find((s) => s.getSlotElementId() === slotId);

        if (slot) {
          window.googletag.destroySlots([slot]);
          definedSlots.delete(slotId);
        }
      }
    };
  }, [adUnitPath, slotId]);

  return <div id={slotId} ref={adRef} />;
};

AdComponent.propTypes = {
  adUnitPath: PropTypes.string,
  slotId: PropTypes.string
};

export default AdComponent;
